var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVehicleStatusBackground = function SvgVehicleStatusBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 77,
    viewBox: "0 0 252 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_b_33_2996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.162 0L0 76.6H252V44.6798L159.162 0Z",
    fill: "#253F73"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_33_2996",
    x: -80,
    y: -80,
    width: 412,
    height: 236.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_33_2996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_33_2996",
    result: "shape"
  })))));
};
export { SvgVehicleStatusBackground as ReactComponent };
export default __webpack_public_path__ + "assets/91c88212.svg";